// // components/AceDentalLogo.jsx
// import React from 'react';

// const AceDentalLogo = ({ className = "" }) => {
//   return (
//     <svg 
//       xmlns="http://www.w3.org/2000/svg" 
//       width="160" 
//       height="50" 
//       viewBox="0 0 160 50"
//       className={className}
//     >
//       <rect width="160" height="50" fill="#000000" rx="8"/>
//       <text 
//         x="80" 
//         y="28" 
//         textAnchor="middle"
//         fontFamily="'Segoe UI', Arial, sans-serif"
//         fontSize="20"
//         fontWeight="700"
//         fill="#ffffff"
//       >
//         ACE DENTAL
//       </text>
//       <text 
//         x="80" 
//         y="42" 
//         textAnchor="middle"
//         fontFamily="'Segoe UI', Arial, sans-serif"
//         fontSize="14"
//         fontWeight="600"
//         fill="#60a5fa"
//       >
//         LAB
//       </text>
//     </svg>
//   );
// };

// export default AceDentalLogo;

// components/AceDentalLogo.jsx
import React from 'react';

const AceDentalLogo = ({ className = "", size = "medium" }) => {
  const sizes = {
    small: { width: 120, height: 40, fontSize: 16, subSize: 10 },
    medium: { width: 180, height: 60, fontSize: 22, subSize: 14 },
    large: { width: 240, height: 80, fontSize: 28, subSize: 18 }
  };
  
  const { width, height, fontSize, subSize } = sizes[size];

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox={`0 0 ${width} ${height}`}
      className={className}
    >
      {/* Background */}
      <rect width={width} height={height} fill="#fff" rx="10"/>
      
      {/* Main Text - ACE DENTAL */}
      <text 
        x={width/2} 
        y={height/2 + 5} 
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize={fontSize}
        fontWeight="bold"
        fill="#000000"
        letterSpacing="1.5"
      >
        ACE DENTAL
      </text>
      
      {/* Sub Text - LAB */}
      <text 
        x={width/2} 
        y={height/2 + 25} 
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize={subSize}
        fontWeight="600"
        fill="#000000"
        letterSpacing="2.5"
      >
        LAB
      </text>
    </svg>
  );
};

export default AceDentalLogo;